const ENV = process.env.REACT_APP_NODE_ENV;
const BASE_URL_SSD = ENV === 'production' ? process.env.REACT_APP_BASE_URL_SSD : (ENV === 'staging' || ENV === 'development' ) ? process.env.REACT_APP_BASE_URL_SSD_STAGING : 'http://localhost:8080/api';

export const getParamsApi = async (uwi, email) => {

  try {
    console.log('Fetching forecast parameters for well ' + uwi + '...');

    const options = {
      method: 'GET',
      headers: {
        'x-api-key': process.env.REACT_APP_API_KEY,
        'Content-Type': 'application/json',
        'uwi': uwi,
        'email': email
      },
    };

    let result = await fetch(`${BASE_URL_SSD}/wells/params`, options);

    if (result.status === 200) {
      let params = await result.json();
      return params;
    };
  } catch (error) {
    console.log('Error fetching forecast parameters!');
    console.log(error);
    return false;
  };
};

export const getWellApi = async (uwi, email) => {

  try {
    console.log('Fetching well ' + uwi + '...');

    const options = {
      method: 'GET',
      headers: {
        'x-api-key': process.env.REACT_APP_API_KEY,
        'Content-Type': 'application/json',
        'uwi': uwi,
        'email': email
      },
    };

    let result = await fetch(`${BASE_URL_SSD}/wells/production`, options);

    if (result.status === 200) {
      const well = await result.json();
      return well;
    };
  } catch (error) {
    console.log('Error fetching forecast parameters!');
    console.log(error);
    return false;
  };
};

export const saveParamsApi = async (well, email) => {
  try {
    console.log('Saving forecast parameters for well ' + well?.uwi + '...');

    let wellParams = {...well?.params};
    const wellFluids = Object.keys(wellParams)?.filter(f => f !== 'cutoff');

    for (let fluid of wellFluids) {
      wellParams[fluid] = {...wellParams?.[fluid], outliers: []};
    };


    let newWell = {
      uwi: well.uwi,
      createdBy: email,
      lastModified: new Date(),
      pool: well?.details?.pool_name?.toUpperCase() || "UNDEFINED",
      field: well?.details?.field_name?.toUpperCase() || "UNDEFINED",
      producing: well?.details?.producing_formation?.toUpperCase() || "UNDEFINED",
      trajectory: well?.details?.trajectory?.toUpperCase() || "UNDEFINED",
      licensee: well?.details?.licensee?.toUpperCase() || "UNDEFINED",
      surfaceLatitude: well?.details?.surface_latitude || 0,
      surfaceLongitude: well?.details?.surface_longitude || 0,
      bottomLatitude: well?.details?.bottom_latitude || 0,
      bottomLongitude: well?.details?.bottom_longitude || 0,
      params: wellParams || {}
    };

    const res = await fetch(`${BASE_URL_SSD}/wells`, {
      method: 'POST',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': process.env.REACT_APP_API_KEY,
        'email': email
      },
      body: JSON.stringify({wells: [newWell]})
    });
    if (res.status === 200) {
      console.log('Well ' + well?.uwi + ' saved to the database');
      return { uwi: well.uwi, success: true, date: new Date().toLocaleString()};
    } else {
      console.log('Could not save well ' + well?.uwi + '!');
      return { success: false, date: new Date().toLocaleString()};
    };
    
  } catch (error) {
    console.log('Error fetching forecast parameters!');
    console.log(error);
    return false;
  };
};

export const deleteParamsApi = async (uwi, email) => {
  try {

    const res = await fetch(`${BASE_URL_SSD}/wells`, {
      method: 'DELETE',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': process.env.REACT_APP_API_KEY,
      },
      body: JSON.stringify({email: email, uwi: uwi})
    });
    if (res.status === 200) {
      console.log('Forecast parameters deleted for well ' + uwi);
      return true;
    } else {
      console.log('Could not delete forecast parameters for well ' + uwi + '!');
      return false;
    };
    
  } catch (error) {
    console.log('Error deleting forecast parameters!');
    console.log(error);
    return false;
  };
};
